import { BaseError } from '../../../errors/base.js';
import { subtractAmounts } from '../../../utils/tokenUtils.js';

class AmountMismatchError extends BaseError {
    /**
     * @param requested
     * @param fulfilled
     * @param nextFulfillable - smallest higher (or null)
     */
    constructor({ requested, fulfilled, nextFulfillable, }) {
        const parts = [
            `Requested: ${requested.amount.toString()} (decimals ${requested.decimals})`,
            `Fulfilled: ${fulfilled.amount.toString()}`,
            nextFulfillable
                ? `Next possible: ${nextFulfillable.amount.toString()}`
                : undefined,
        ].filter(Boolean);
        super("Unable to fulfill requested amount", {
            metaMessages: parts,
        });
        this.name = "AmountMismatchError";
        this.requested = requested;
        this.fulfilled = fulfilled;
        this.shortfall = subtractAmounts(requested, fulfilled);
        this.nextFulfillable = nextFulfillable;
        this.overage = nextFulfillable
            ? subtractAmounts(nextFulfillable, requested)
            : null;
    }
}

export { AmountMismatchError };
//# sourceMappingURL=amountMismatchError.js.map
